import React, { useState } from 'react';
import Typography from '../atoms/Typography';
import Button from '../atoms/Button';
import PDFUploader from '../molecules/PDFUploader';
import TechStackInput from '../molecules/TechStackInput';
import FloatingModelsContainer from '../organisms/FloatingModelsContainer';
import './LandingTemplate.css';

const LandingTemplate = ({ onStartClick, onPdfTextExtracted, onTechTextSubmitted, interviewType, onInterviewTypeChange }) => {
  const [extractedText, setExtractedText] = useState('');
  const [techText, setTechText] = useState('');

  const handleTextExtracted = (text) => {
    setExtractedText(text);
    if (onPdfTextExtracted) {
      onPdfTextExtracted(text);
    }
  };

  const handleTechTextSubmitted = (text) => {
    setTechText(text);
    if (onTechTextSubmitted) {
      onTechTextSubmitted(text);
    }
  };

  const handleInterviewTypeToggle = (type) => {
    if (onInterviewTypeChange) {
      onInterviewTypeChange(type);
    }
  };

  const canStartInterview = interviewType === 'behavioral' ? extractedText : techText;

  return (
    <div className="landing-template">
      <FloatingModelsContainer />
      
      <div className="landing-content glass-card">
        <div className="landing-header">
          <div className="interview-icon">AI</div>
          <Typography variant="h1" color="white" align="center" className="heading-xl landing-title">
            Super Interview Pro
          </Typography>
          <Typography variant="subtitle1" color="dark" align="center" className="landing-subtitle">
            Practice interviews with our AI-powered interview coach
          </Typography>
        </div>
        
        {/* Interview Type Selection */}
        <div className="interview-type-selection">
          <Typography variant="h3" color="white" align="center" className="section-title">
            Choose Interview Type
          </Typography>
          
          <div className="interview-type-buttons">
            <button
              className={`interview-type-btn ${interviewType === 'behavioral' ? 'active' : ''}`}
              onClick={() => handleInterviewTypeToggle('behavioral')}
            >
              <div className="interview-type-icon">👥</div>
              <Typography variant="h4" className="interview-type-title">
                Behavioral Interview
              </Typography>
              <Typography variant="body2" className="interview-type-description">
                Practice behavioral questions based on your resume and experience
              </Typography>
            </button>
            
            <button
              className={`interview-type-btn ${interviewType === 'technical' ? 'active' : ''}`}
              onClick={() => handleInterviewTypeToggle('technical')}
            >
              <div className="interview-type-icon">⚙️</div>
              <Typography variant="h4" className="interview-type-title">
                Technical Interview
              </Typography>
              <Typography variant="body2" className="interview-type-description">
                Deep-dive technical questions about specific technologies and concepts
              </Typography>
            </button>
          </div>
        </div>

        {/* Content based on interview type */}
        {interviewType === 'behavioral' ? (
          <div className="behavioral-setup">
            <PDFUploader onTextExtracted={handleTextExtracted} />
            {extractedText && (
              <Typography variant="body2" color="success" align="center" className="success-message">
                Resume/job description loaded! Start the interview to begin practicing.
              </Typography>
            )}
            <Button 
              onClick={onStartClick} 
              variant="primary" 
              size="large"
              className="btn btn-primary landing-cta"
              disabled={!canStartInterview}
            >
              Start Behavioral Interview
            </Button>
          </div>
        ) : (
          <div className="technical-setup">
            <TechStackInput onTextSubmitted={handleTechTextSubmitted} />
            {techText && (
              <Typography variant="body2" color="success" align="center" className="success-message">
                Technical requirements set! Ready for your technical interview.
              </Typography>
            )}
            <Button 
              onClick={onStartClick} 
              variant="primary" 
              size="large"
              className="btn btn-primary landing-cta"
              disabled={!canStartInterview}
            >
              Start Technical Interview
            </Button>
          </div>
        )}
        
        {!canStartInterview && (
          <Typography variant="caption" color="dark" align="center" className="upload-hint">
            {interviewType === 'behavioral' 
              ? 'Please upload your resume or job description as PDF to begin'
              : 'Please enter technical requirements or job description to begin'
            }
          </Typography>
        )}
      </div>
    </div>
  );
};

export default LandingTemplate; 